const degToRad = (deg) => (Math.PI / 180) * deg;

const square = (n) => n * n;

/**
 * @typedef Branch
 * @type {object}
 * @property {string} name
 * @property {string} code
 * @property {number} lat - latitude
 * @property {number} long - longitude
 */

/**
 * @typedef Point
 * @type {object}
 * @property {number} lat - latitude
 * @property {number} long - longitude
 */

/**
 * Calculate the distance between two coordinates
 *
 * @param {Point} p1 - point 1
 * @param {Point} p2 - point 2
 * @return {number} distance between both points in metres
 */
const getDistance = (p1, p2) => {
  const earthRadius = 6371e3;
  const lat1Rads = degToRad(p1.lat);
  const lat2Rads = degToRad(p2.lat);
  const latDiff = degToRad(p2.lat - p1.lat);
  const longDiff = degToRad(p2.long - p1.long);
  const a =
    square(Math.sin(latDiff / 2)) +
    Math.cos(lat1Rads) * Math.cos(lat2Rads) * square(Math.sin(longDiff / 2));
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return earthRadius * c;
};

const distanceComp = (d1, d2) => d1.distance - d2.distance;

export const mapToMainBranch = (responsibleTeamCode) => {
  const remappedTeams = {
    HBIC: "HBII",
    HBIE: "HBII",
    HBSS: "HBII",
    HKCT: "HKCA",
    DONT: "DONC",
    HDOS: "HDOV",
    HUGS: "HUGR",
    HNHC: "HHUN",
    HNHN: "HHUN",
    LALD: "LIVG",
    LISA: "LIVG",
    LIVM: "LIVG",
    LIVR: "LIVG",
    LIVX: "LIVG",
    LPET: "LIVG",
    HXND: "HNNN",
    HXSD: "NONF",
    HXPD: "HNPT",
    NONF: "HNPT",
    HKRG: "HKRA",
    HSTS: "HSTO",
    HTNS: "HTNE",
    HBUE: "HBUP",
    HBUI: "HBUP",
    HBUO: "HBUP",
    HBUS: "HBUP",
    HKDA: "HBUP",
    HWAS: "HWAT",
    HLLS: "DONC",
  };
  if (Object.keys(remappedTeams).includes(responsibleTeamCode)) {
    return remappedTeams[responsibleTeamCode];
  }
  return responsibleTeamCode;
};

/**
 * Gets the nearest branch using latitude and longitude
 *
 * @param {Point} location
 * @param {Array<Branch>} branches
 * @return {Branch} closest branch
 */
export default (location, branches) => {
  const sorted = branches
    .map((branch) => ({
      ...branch,
      distance: getDistance(location, branch),
    }))
    .sort(distanceComp);
  return sorted[0];
};
